const calculatorRange = document.getElementById('calculator-range')
const calculatorScenario = document.getElementById('calculator-scenario')
const earningsResult = document.getElementById('earnings-result')

function handleInputChange(e) {
  const val = e.target.value;
  let earnings = (99*0.25) * val;
  calculatorScenario.innerText = `${val} new referral${val!=="1"?"s":""} every month`;
  earningsResult.innerText = `$${earnings}`;
}

calculatorRange.addEventListener('input', handleInputChange);
